// extracted by mini-css-extract-plugin
module.exports = {"main-component":"customerLike_main-component__26y48"};